import { render, staticRenderFns } from "./ChatroomWrapper.vue?vue&type=template&id=24207683&scoped=true"
import script from "./ChatroomWrapper.vue?vue&type=script&lang=ts"
export * from "./ChatroomWrapper.vue?vue&type=script&lang=ts"
import style0 from "./ChatroomWrapper.vue?vue&type=style&index=0&id=24207683&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24207683",
  null
  
)

export default component.exports